import { render, staticRenderFns } from "./setupList.vue?vue&type=template&id=29c2eab1&scoped=true"
import script from "./setupList.vue?vue&type=script&lang=js"
export * from "./setupList.vue?vue&type=script&lang=js"
import style0 from "./setupList.vue?vue&type=style&index=0&id=29c2eab1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c2eab1",
  null
  
)

export default component.exports